var TabEquipmentHistoricModule = /** @class */ (function () {
    function TabEquipmentHistoricModule() {
    }
    return TabEquipmentHistoricModule;
}());
export { TabEquipmentHistoricModule };
